import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}
// 结算单弹屏-我知道了，明日提醒
export const settlementReminderApi = (data: any) =>
  request.post('/financial/marketingSettlementCrm/reminder', data, jsonHeaderConfig)
// 校验机构实名认证
export const realNameCertificationApi = (data: any) =>
  request.get('/financial/marketingSettlementCrm/realNameCertification', {
    params: data
  })
// 发送签收验证码
export const sendSignatureCodeApi = (data: any) =>
  request.request({
    url: '/financial/marketingSettlementCrm/sendSignatureCode',
    method: 'PATCH',
    data
  })
// 结算单签收
export const receivingSettlementApi = (data: any) =>
  request.post('/financial/marketingSettlementCrm/receiving', data, jsonHeaderConfig)
// 结算单列表
export const settlementListApi = (data: any) =>
  request.post('/financial/marketingSettlementCrm/settlementList', data, jsonHeaderConfig)
// 结算单详情
export const settlementDetailApi = (data: any) =>
  request.post('/financial/marketingSettlementCrm/detail', data, {
    responseType: 'blob'
  })
// 结算单下载
export const settlementDownloadApi = '/financial/marketingSettlementCrm/download'
// 登录后，需查找是否有需要确认的结算单
export const getSettlementPopUpApi = () =>
  request.get('/financial/marketingSettlementCrm/getSettlementPopUp', {})

// 门店管理 分页
export const storeManagementPage = (data: any) =>
  request.post('/admin/cps/storeManagement/page', data, jsonHeaderConfig)

// 根据门店查询购买明细
export const storeQueryStoreWorkMachineInfos = (data: any) =>
  request.post('/admin/cps/storeManagement/queryStoreWorkMachineInfos', data, jsonHeaderConfig)

// 新增购买明细
export const storeSaveStoreWorkMachineInfos = (data: any) =>
  request.post('/admin/cps/storeManagement/saveStoreWorkMachineInfos', data, jsonHeaderConfig)

// 用户费用明细-列表
export const userChargeDetailList = (data: any) =>
  request.post('/datacenter/cps/userChargeDetail/list', data, jsonHeaderConfig)

// 用户费用明细-导出
export const userChargeDetailExport = '/datacenter/cps/userChargeDetail/export'

// 门店结算-列表
export const storeSettlementList = (data: any) =>
  request.post('/datacenter/cps/storeSettlement/list', data, jsonHeaderConfig)

// 门店结算-门店授权
export const storeEmpower = (data: any) =>
  request.post('/admin/cps/storeManagement/empower', data, jsonHeaderConfig)

// 门店结算-门店授权刷新
export const storeEmpowerRefresh = (data: any) => {
  return request.get(`/admin/cps/storeManagement/empowerRefresh/${data}`, null, jsonHeaderConfig)
}
// cps做单明细表-列表-员工
export const employeeDetail = (data: any) =>
  request.post('/datacenter/cps/mark/order/page_by_user', data, jsonHeaderConfig)

// cps做单明细表-列表-员工-汇总
export const employeeDetailTotal = (data: any) =>
  request.post('/datacenter/cps/mark/order/total_by_user', data, jsonHeaderConfig)

// cps做单明细表-列表-部门
export const departmentDetail = (data: any) =>
  request.post('/datacenter/cps/mark/order/page_by_dept', data, jsonHeaderConfig)

// cps做单明细表-列表-部门-汇总
export const departmentDetailTotal = (data: any) =>
  request.post('/datacenter/cps/mark/order/total_by_dept', data, jsonHeaderConfig)

// cps做单明细表-列表-员工-导出
export const employeeDetailExport = '/datacenter/cps/mark/order/export_by_user'

// cps做单明细表-列表-部门-导出
export const departmentDetailExport = '/datacenter/cps/mark/order/export_by_dept'

// 表头
export const webTitleColumnResultList = (data: any) =>
  request.post('/paas/page/webTitleColumnResultList', data, jsonHeaderConfig)

// cps做单明细表-弹窗-拨打明细
export const callDetail = (data: any) =>
  request.post('/datacenter/cps/mark/order/callAlarmList', data, jsonHeaderConfig)

// cps做单明细表-弹窗-微信明细
export const wxDetail = (data: any) =>
  request.post('/datacenter/weixin/alarm/page', data, jsonHeaderConfig)

// cps做单明细表-查询-2级部门枚举
export const getSecondaryDpt = (data?: any) => {
  return request.post('/admin/department/list_cps_stores', data, jsonHeaderConfig)
}

// cps查询门店地址明细
export const queryStoreAddressInfos = (data?: any) => {
  return request.post('/admin/cps/storeManagement/queryStoreAddressInfos', data, jsonHeaderConfig)
}

// 新增门店地址明细
export const saveStoreAddressInfos = (data?: any) => {
  return request.post('/admin/cps/storeManagement/saveStoreAddressInfos', data, jsonHeaderConfig)
}

// 门店结算-导出
export const storeSettlementExport = '/datacenter/cps/storeSettlement/export'
// 获取门店授权数量
export const getStoreEmpowerCount = (data?: any) => {
  return request.get(
    `/financial/mall/trade/canRenewNum/${data.storeId}/${data.itemId}`,
    null,
    jsonHeaderConfig
  )
}

// cps结算单列表
export const cpsSettlementListApi = (data: any) =>
  request.post('/financial/cps/marketingSettlement/settlementList', data, jsonHeaderConfig)

// cps结算单详情
export const cpsSettlementDetailApi = (data: any) =>
  request.post('/financial/cps/marketingSettlement/detail', data, {
    responseType: 'blob'
  })
// cps结算单下载
export const cpsSettlementDownloadApi = '/financial/cps/marketingSettlement/download'

// cps结算单签收
export const cpsReceivingSettlementApi = (data: any) =>
  request.post('/financial/cps/marketingSettlement/receiving', data)

// 创收金额贡献

export const analysisIncome = (data: any) =>
  request.post('/datacenter/trend/analysis/income', data, jsonHeaderConfig)

export const conversionRate = (data: any) =>
  request.post('/datacenter/cps/dashboard/conversionRate', data, jsonHeaderConfig)
// cps结算单重新生成
export const cpsSettlementReGenerateApi = (data: any) =>
  request.post('/financial/cps/marketingSettlement/rebuild', data)

// cps结算单重新发送
export const cpsSettlementReSendApi = (data: any) =>
  request.post('/financial/cps/marketingSettlement/resend', data)

// cps结算单驳回
export const cpsSettlementRejectApi = (data: any) =>
  request.post('/financial/cps/marketingSettlement/rejected', data)

// 用户费用明细-金额合计
export const userChargeDetailTotal = (data: any) =>
  request.post('/datacenter/cps/userChargeDetail/total', data, jsonHeaderConfig)

// 门店结算-合计
export const storeSettlementTotal = (data: any) =>
  request.post('/datacenter/cps/storeSettlement/total', data, jsonHeaderConfig)

// 门店账户管理 export
export const transactionExport = '/financial/cps/store/transaction/detail/export'

// 门店账户管理-合计
export const sumTransactionAmount = (data: any) =>
  request.post(
    '/financial/cps/store/transaction/detail/sumTransactionAmount',
    data,
    jsonHeaderConfig
  )

// 保证金列表导出
export const accountExport = '/financial/cps/store/account/export'

// 门店账户管理-合计
export const accountTotal = (data: any) =>
  request.post('/financial/cps/store/account/total', data, jsonHeaderConfig)
// * 获取城市列表

export const getCityList = (data: any) =>
  request.get('/admin/district/cityList', {
    params: data
  })

// 查询所有门店违规订单记录
export const violationAllList = (data: any) =>
  request.post('/crm/cps/order/violation/allList', data, jsonHeaderConfig)

// 违规情况修改
export const violationUpdate = (data: any) =>
  request.post('/crm/cps/order/violation/update', data, jsonHeaderConfig)

// 漏斗转化 - 通话数据
export const transformationCallData = (data: any) =>
  request.post('/datacenter/cps/funnel/transformation/callData', data, jsonHeaderConfig)

// 漏斗转化-通话数据导出
export const callDataExport = '/datacenter/cps/funnel/transformation/callDataExport'

// 漏斗转化-通话数据导出
export const firstCallTimelinessExport =
  '/datacenter/cps/funnel/transformation/firstCallTimelinessExport'

// 首呼时效列表
export const pageFirstCallTimeliness = (data: any) =>
  request.post(
    '/datacenter/cps/funnel/transformation/pageFirstCallTimeliness',
    data,
    jsonHeaderConfig
  )
